function formatTime(tanggal) {
  const date = new Date(tanggal);

  // Format jam:menit -> 18:25
  const options = { hour: "2-digit", minute: "2-digit", hour12: false };
  return date.toLocaleTimeString("en-GB", options);
}

export default formatTime;